const translations = {
    fr: {
        brand: {
            name: 'MAF Industrie',
            title: 'MAF INDUSTRIE',
            subtitle: 'Studio tufting et objets 3D'
        },
        nav: {
            home: 'Accueil',
            tufting: 'Tufting',
            cards: 'Cartes 3D',
            faq: 'FAQ',
            contact: 'Contact',
            order: 'Commander',
            languageLabel: 'Langue',
            openMenu: 'Menu',
            closeMenu: 'Fermer'
        },
        footer: {
            headline: 'Pieces sur mesure et objets en relief.',
            note: 'Tufting, reliefs et cartes Pokemon 3D.',
            shop: 'Boutique'
        },
        common: {
            all: 'Tout',
            available: 'Disponibles',
            sold: 'Vendu',
            availableStatus: 'Disponible',
            soldStatus: 'Vendu',
            buy: 'Acheter',
            quote: 'Sur devis',
            contactStudio: "Contacter l'atelier",
            contactMe: 'Me contacter',
            viewPieces: 'Voir les pieces',
            viewFaq: 'Voir la FAQ',
            openChannel: 'Ouvrir la chaine',
            allLinks: 'Tous les liens',
            anonymous: 'Anonyme',
            lightbox: {
                openLabel: 'Voir en grand',
                closeLabel: 'Fermer la vue',
                prev: 'Média précédent',
                next: 'Média suivant',
                countLabel: '{current} / {total}'
            }
        },
        linksPage: {
            eyebrow: 'Contact',
            title: "Liens pour suivre l'atelier et commander.",
            lead:
                'Reseaux, boutique et contact direct pour les demandes sur mesure.',
            instagramDesc: 'Actus, work in progress et nouvelles pieces.',
            emailDesc: 'Contact direct pour les commandes.',
            siteText: 'Site vitrine',
            siteDesc: 'Portfolio et infos sur les pieces.',
            vintedText: 'Vinted',
            vintedDesc: 'Boutique pour les pieces disponibles.',
            twitchText: 'Twitch',
            twitchDesc: 'Lives atelier ou gaming, selon les sessions.'
        },
        home: {
            hero: {
                eyebrow: 'MAF INDUSTRIE',
                title:
                    'Atelier creatif pour pieces tufting et cartes Pokemon 3D.',
                lead:
                    'Des nuances chaleureuses, des couleurs organiques et des projets sur mesure pour donner du relief a votre univers.',
                actions: {
                    tufting: 'Explorer le tufting',
                    cards: 'Cartes Pokemon 3D'
                },
                stats: [
                    { value: 'Fait main', label: 'Atelier' },
                    { value: 'Pieces uniques', label: 'Chaque creation' },
                    { value: 'Sur commande', label: 'Contact direct' }
                ]
            },
            heroShots: {
                tufting: 'Tufting',
                floral: 'Parterre floral',
                sunMirror: 'Soleil miroir',
                totoro: 'Totoro',
                card3d: 'Carte 3D',
                relief3d: 'Relief 3D'
            },
            heroCaption: {
                chip: 'Apercu rapide',
                title: 'Reliefs & volumes',
                description: 'Un mix tufting et 3D pour des pieces originales.',
                link: "Contacter l'atelier"
            },
            highlights: [
                {
                    title: 'Tufting sur mesure',
                    description:
                        'Des tapis a poser au sol, mais aussi des pieces murales, adaptes a vos couleurs, formats et ambiance.',
                    cta: 'Voir le process'
                },
                {
                    title: 'Cartes Pokemon 3D',
                    description:
                        'Cartes en relief avec decoupes superposees pour un effet profondeur.',
                    cta: 'Decouvrir la collection'
                },
                {
                    title: 'FAQ',
                    description:
                        'Formats, delais, budget et entretien pour vos pieces.',
                    cta: 'Lire la FAQ'
                }
            ],
            studio: {
                eyebrow: 'Studio',
                title: 'Pieces recentes',
                note: 'Petit apercu de mes dernieres creations.',
                types: {
                    tufting: 'Tufting',
                    cards: 'Carte 3D'
                }
            },
            twitch: {
                eyebrow: 'Live',
                title: 'Twitch, en douceur',
                note:
                    'Quelques lives atelier ou gaming, sans que ce soit central.',
                cardTitle: 'Suivre le studio en direct',
                cardNote:
                    'Je lance un stream quand je bosse sur une piece ou pour une session gaming.'
            },
            reviews: {
                eyebrow: 'Avis',
                title: 'Avis clients',
                average: 'Moyenne sur {count} avis',
                empty: "Pas encore d'avis."
            }
        },
        tufting: {
            hero: {
                eyebrow: 'Tufting',
                title: 'Pieces textiles en relief, 100% fait main.',
                lead:
                    'Tapis muraux, formats custom ou objets decoratifs. Chaque piece est unique, pensee pour votre espace.',
                note: 'Besoin de details sur les formats, delais ou entretien ?',
                noteLink: 'Voir la FAQ',
                quote: 'Demander un devis',
                estimate: 'Estimer un tapis'
            },
            collage: {
                medievalAlt: 'Tapis Medieval Banner',
                lavaAlt: 'Tapis Lampe a lave',
                sunAlt: 'Tapis Soleil miroir',
                floralAlt: 'Tapis Parterre floral'
            },
            process: {
                eyebrow: 'Process',
                title: 'Un rythme simple et clair',
                note:
                    'Chaque piece est preparee en atelier, avec un suivi visuel.',
                steps: [
                    {
                        title: 'Brief rapide',
                        description:
                            'On definit la taille, les couleurs et le motif de votre piece.'
                    },
                    {
                        title: 'Tufting',
                        description:
                            'Application du fil, reliefs et volume pour le bon rendu.'
                    },
                    {
                        title: 'Finitions',
                        description: 'Colle, tonte et coupe details.'
                    }
                ]
            },
            library: {
                eyebrow: 'Library',
                title: 'Selection de pieces tufting',
                note:
                    'Pieces uniques. Commande personnalisee sur demande par mail ou DM Instagram.'
            },
            filters: {
                all: 'Tout',
                available: 'Disponibles',
                sold: 'Vendu'
            },
            status: {
                available: 'Disponible',
                sold: 'Vendu'
            },
            thumbnails: {
                view: 'Voir {title} {index}'
            },
            dimensionsFallback: 'Dimensions a confirmer',
            quote: 'Sur devis',
            buy: 'Acheter',
            cta: {
                eyebrow: 'Sur mesure',
                title: "Envie d'une piece unique ?",
                note:
                    'Envoyez un message avec vos idees, formats et couleurs pour lancer votre projet.',
                button: "Contacter l'atelier"
            }
        },
        cards: {
            hero: {
                eyebrow: 'Cartes Pokemon 3D',
                title: 'Cartes en relief pour collectionneurs.',
                lead:
                    'Des cartes Pokemon decoupees et superposees pour un effet 3D spectaculaire.',
                contact: 'Me contacter'
            },
            signature: {
                eyebrow: 'Signature',
                title: 'Pourquoi le 3D change tout',
                note:
                    "Une approche artisanale qui transforme une carte en objet d'art."
            },
            features: [
                {
                    title: 'Relief multi couches',
                    description:
                        'Chaque carte est decoupee et superposee pour creer un vrai volume.'
                },
                {
                    title: 'Lumiere et profondeur',
                    description:
                        "Effets d'ombre et de contraste pour faire ressortir les details."
                },
                {
                    title: 'Format collector',
                    description:
                        'Edition limitee, chaque carte est choisie ensemble selon la faisabilite.'
                }
            ],
            collection: {
                eyebrow: 'Collection',
                title: 'Collection de cartes 3D',
                note:
                    'Formats classiques, reliefs profonds et finitions sur mesure.'
            },
            filters: {
                all: 'Tout',
                available: 'Disponibles',
                sold: 'Vendu'
            },
            status: {
                available: 'Disponible',
                sold: 'Vendu'
            },
            optionLabels: {
                wallMount: 'Attache murale',
                magnet: 'Magnetique',
                easel: 'Petit chevalet'
            },
            media: {
                imageLabel: '{title} {index}',
                videoLabel: '{title} video {index}',
                viewLabel: 'Voir {label}'
            },
            buy: 'Acheter',
            quote: 'Sur devis',
            request: {
                eyebrow: 'Projet cartes',
                title: 'Exprime ton projet de carte 3D',
                lead:
                    'Cherche le Pokémon qui te plaît et on construira ton projet ensemble.',
                openButton: 'Composer une demande 3D',
                searchLabel: 'Pokemon à chercher',
                searchPlaceholder: 'Pikachu, Dracaufeu...',
                searchButton: 'Rechercher les cartes',
                searchError: 'Impossible de joindre tcgdex.dev. {message}',
                searching: 'Recherche en cours…',
                searchEmpty: 'Commence par taper un nom de Pokémon.',
                noResults: 'Aucune carte trouvée pour «{query}».',
                selectionInstruction:
                    'Tu peux sélectionner plusieurs cartes, même de Pokémon différents.',
                selectButton: 'Ajouter',
                selectedButton: 'Ajoutée',
                selectedCards: 'Cartes sélectionnées',
                selectionHint: 'Elles seront listées dans ton mail.',
                selectionEmpty: 'Aucune carte sélectionnée pour l’instant.',
                removeCard: 'Retirer {name}',
                loadMore: 'Charger plus de cartes',
                form: {
                    eyebrow: 'Contact direct',
                    emailLabel: 'Votre email',
                    messageLabel:
                        'Détails du projet (Pokémon favori, budget, et tout autre info..)',
                    submit: 'Envoyer la demande',
                    subject: 'Demande cartes 3D',
                    emptySelection:
                        'Sélectionne au moins une carte avant d’envoyer.',
                    submitError: 'Une erreur est survenue lors de l’envoi. {message}',
                    botFieldLabel: 'Ne remplis pas ce champ',
                    emailRequired: 'Ajoute ton email pour continuer.'
                },
                warning:
                    `Toutes les cartes ne sont pas réalisables.
                     Le prix du projet dépend du prix de la carte`
                ,
                toastSuccess: 'Demande envoyée ! Je te recontacte rapidement.'
                ,
                legend:
                    'L’icône signale une carte déjà confirmée comme réalisable.'
                ,
                realisableLegend:
                    'L’icône signale une carte déjà confirmée comme réalisable.'
            },
            process: {
                eyebrow: 'Fabrication',
                title: 'Un process clair et precis',
                optionsTitle: "Options d'exposition",
                options:
                    'Attache murale 2 €, petit chevalet 5 €, magnet 3€.',
                steps: [
                    {
                        title: 'Selection',
                        description:
                            'Choix de la carte, des niveaux et du rendu final.'
                    },
                    {
                        title: 'Decoupe fine',
                        description:
                            'Precision et nettoyage pour des contours nets.'
                    },
                    {
                        title: 'Assemblage',
                        description:
                            'Superposition a la main pour un relief uniforme.'
                    }
                ]
            },
            cta: {
                eyebrow: 'Edition limitee',
                title: 'Discutons du Pokemon qui vous inspire.',
                note:
                    "Toutes les cartes ne sont pas realisables. On discute d'un Pokemon, puis on choisit ensemble une carte avant de la realiser en 3D.",
                contact: 'Me contacter'
            }
        },
        faq: {
            hero: {
                eyebrow: 'FAQ',
                title: 'Questions frequentes sur le tufting et les cartes 3D.',
                lead:
                    'Formats, delais, options et entretien pour preparer votre commande.'
            },
            actions: {
                viewPieces: 'Voir les pieces',
                contact: "Contacter l'atelier"
            },
            heroCard: {
                chip: 'Infos pratiques',
                title: 'Tout est detaille ici',
                note:
                    'Si un point manque, ecrivez-moi et je vous reponds rapidement.',
                link: 'Poser une question'
            },
            list: {
                eyebrow: 'Infos',
                title: 'Reponses aux questions courantes',
                note:
                    "Formats, prix, delais et options : l'essentiel pour commander sereinement."
            },
            groups: {
                tufting: 'Tufting',
                cards: 'Cartes 3D'
            },
            tuftingItems: [
                {
                    question: 'Quels formats proposez-vous ?',
                    answer:
                        "Jusqu'a 75 x 75 cm, du petit au grand. Accroche murale possible en option gratuite."
                },
                {
                    question: 'Comment se passe une commande sur mesure ?',
                    answer:
                        "On echange sur le visuel, les couleurs, la taille et l'ambiance, puis je lance la creation. Acompte de 30% avant le debut."
                },
                {
                    question: 'Quels sont les delais de fabrication ?',
                    answer: 'En moyenne 1 a 3 semaines selon mon planning.'
                },
                {
                    question: 'Quel budget prevoir ?',
                    answer:
                        "Le prix depend du format, des details et du temps de travail. Devis gratuit sur demande. Compter environ 40 € pour un petit et jusqu'a 200 € pour un tres grand."
                },
                {
                    question: 'Puis-je choisir mes couleurs et motifs ?',
                    answer:
                        'Oui, tout est personnalisable : palette, style et rendu final. Plus le motif est complexe, plus le temps de travail (et donc le prix) augmente.'
                },
                {
                    question: 'Comment accrocher une piece murale ?',
                    answer:
                        'Je pose des crochets pour accrocher au mur avec une vis ou un clou, avec plusieurs points selon le poids du tapis.'
                },
                {
                    question: 'Comment entretenir un tapis ?',
                    answer:
                        "Aspiration douce. Ne pas tirer les fils qui depassent : les couper de preference. Lavage localise a l'eau, sans frotter fort. Les premiers jours, le tapis peut perdre quelques fils ou laisser apparaitre des fils plus longs ; dans ce cas, les couper delicatement a la bonne hauteur."
                },
                {
                    question: 'Livrez-vous partout ?',
                    answer:
                        'Livraison via Vinted ou Leboncoin pour simplifier et reduire le cout. Possible aussi par envoi personnel, avec des frais supplementaires selon les tarifs (La Poste, etc.).'
                },
                {
                    question: 'Acceptez-vous les retours ?',
                    answer:
                        'Les pieces sur mesure ne sont pas retournables, sauf probleme de fabrication.'
                }
            ],
            cardsItems: [
                {
                    question:
                        "Quelles options d'exposition proposez-vous (attache murale, chevalet) ?",
                    answer:
                        "Deux options sont possibles : une attache murale (2 €) ou un petit chevalet de support (5 €), selon l'effet souhaite."
                },
                {
                    question: 'Comment accrocher une carte 3D au mur ?',
                    answer:
                        "Un clou ou une vis suffit. Avec l'attache murale, la pose est simple."
                },
                {
                    question: 'Quels formats sont disponibles pour les cartes 3D ?',
                    answer:
                        "Pour l'instant, Pokemon uniquement. D'autres licences arrivent bientot."
                },
                {
                    question: 'Quels delais pour une carte 3D sur mesure ?',
                    answer:
                        "Environ une semaine, selon le planning du moment."
                },
                {
                    question: 'Les cartes 3D sont-elles retournables ?',
                    answer:
                        'Pas de retour possible pour les pieces sur mesure, sauf souci de fabrication.'
                }
            ],
            cta: {
                eyebrow: 'Contact',
                title: 'Une question en plus ?',
                note:
                    'Dites-moi votre idee et votre ambiance, je vous reponds rapidement.',
                contact: "Contacter l'atelier"
            }
        },
        modal: {
            eyebrow: 'Estimation',
            title: 'Estimer un tapis tufting',
            lead:
                'Ajustez la taille pour obtenir une estimation rapide. Max {max} x {max} cm.',
            formSubject: 'Estimation rug - {email}',
            formSubjectFallback: 'Estimation rug - email manquant',
            close: 'Fermer la fenetre',
            dimensions: {
                chip: 'Dimensions',
                note: 'Sur mesure',
                width: 'Largeur',
                height: 'Hauteur'
            },
            options: {
                chip: 'Options',
                note: 'Ajouts',
                wallMount: {
                    label: 'Accroche murale (0€)',
                    short: 'Accroche murale'
                },
                mirror: {
                    label: 'Miroir (15€)',
                    short: 'Miroir'
                },
                shipping: {
                    label: 'Livraison (15€)',
                    short: 'Livraison'
                },
                reference: {
                    label: 'Image de reference (optionnel)',
                    placeholder: 'Ajouter une image',
                    note:
                        'Joignez une image (max 8 Mo). Elle sera envoyee avec la demande.'
                },
                preview: {
                    button: 'Voir un rendu potentiel',
                    processing: 'Rendu en cours...',
                    success:
                        'Apercu genere ({count} couleurs + noir et blanc).',
                    tooMany:
                        'Image trop complexe ({count} couleurs dominantes).',
                    error: 'Impossible de generer le rendu.',
                    note:
                        "Couleurs indicatives : l'algo peut se tromper, on valide ensemble les teintes.",
                    colorsLabel: 'Nombre de couleurs',
                    palette: 'Palette extraite',
                    paletteAvailable: 'Couleurs disponibles',
                    original: 'Photo envoyee',
                    rendered: 'Rendu simplifie'
                }
            },
            breakdown: {
                chip: 'Detail',
                note: 'Materiaux + temps',
                total: 'Total estime',
                footnote: 'Prix indicatif. Le montant final peut varier.'
            },
            cta: {
                title: 'Envie de lancer votre projet ?',
                note:
                    'Laissez votre email pour etre recontacte et parler du projet.',
                primary: 'Commander',
                submit: 'Envoyer la demande',
                emailLabel: 'Votre email',
                emailPlaceholder: 'votre@email.com',
                commentShow: 'Ajouter un commentaire',
                commentHide: 'Masquer le commentaire',
                commentLabel: 'Commentaire (optionnel)',
                commentPlaceholder: 'Votre message...',
                sending: 'Envoi en cours...',
                success: 'Demande envoyee.',
                error: "Erreur d'envoi, reessayez."
            },
            priceLabels: {
                Yarns: 'Fil',
                Cloth: 'Toile',
                'Rug Glue': 'Colle tapis',
                'Anti-Slip Fabric': 'Tissu anti-derapant',
                'Spray Glue': 'Colle spray',
                'Glue Gun': 'Pistolet a colle',
                'Tufting Gun Costs': 'Cout du gun tufting',
                'Mower Costs': 'Cout tondeuse',
                'Working Hours': 'Heures de travail',
                'Edge Cover Strip': 'Bande de finition'
            },
            email: {
                subject: 'Projet tapis tufting',
                greeting: 'Bonjour,',
                intro: 'Je suis interesse par un tapis tufting sur mesure.',
                width: 'Largeur: {value} cm',
                height: 'Hauteur: {value} cm',
                referenceName: 'Image de reference : {value}',
                referenceLink: "Lien de l'image : {value}",
                referenceNote:
                    "Lien non genere. Je joins l'image manuellement.",
                wallMount: 'Accroche murale : 0€',
                mirror: 'Miroir : 15€',
                shipping: 'Livraison : 15€',
                total: 'Total estime: {value}€',
                thanks: 'Merci !'
            }
        }
    },
    en: {
        brand: {
            name: 'MAF Industrie',
            title: 'MAF INDUSTRIE',
            subtitle: 'Tufting studio and 3D pieces'
        },
        nav: {
            home: 'Home',
            tufting: 'Tufting',
            cards: '3D Cards',
            faq: 'FAQ',
            contact: 'Contact',
            order: 'Order',
            languageLabel: 'Language',
            openMenu: 'Menu',
            closeMenu: 'Close'
        },
        footer: {
            headline: 'Custom pieces and relief objects.',
            note: 'Tufting, reliefs and 3D Pokemon cards.',
            shop: 'Shop'
        },
        common: {
            all: 'All',
            available: 'Available',
            sold: 'Sold',
            availableStatus: 'Available',
            soldStatus: 'Sold',
            buy: 'Buy',
            quote: 'On request',
            contactStudio: 'Contact the studio',
            contactMe: 'Contact me',
            viewPieces: 'See the pieces',
            viewFaq: 'See the FAQ',
            openChannel: 'Open the channel',
            allLinks: 'All links',
            anonymous: 'Anonymous',
            lightbox: {
                openLabel: 'View fullscreen',
                closeLabel: 'Close viewer',
                prev: 'Previous media',
                next: 'Next media',
                countLabel: '{current} / {total}'
            }
        },
        linksPage: {
            eyebrow: 'Contact',
            title: 'Links to follow the studio and order.',
            lead: 'Socials, shop and direct contact for custom requests.',
            instagramDesc: 'Updates, work in progress and new pieces.',
            emailDesc: 'Direct contact for orders.',
            siteText: 'Portfolio site',
            siteDesc: 'Portfolio and info about the pieces.',
            vintedText: 'Vinted',
            vintedDesc: 'Shop for available pieces.',
            twitchText: 'Twitch',
            twitchDesc: 'Studio or gaming streams depending on the session.'
        },
        home: {
            hero: {
                eyebrow: 'MAF INDUSTRIE',
                title:
                    'Creative studio for tufted pieces and 3D Pokemon cards.',
                lead:
                    'Warm tones, organic colors and custom projects to bring relief to your world.',
                actions: {
                    tufting: 'Explore tufting',
                    cards: '3D Pokemon Cards'
                },
                stats: [
                    { value: 'Handmade', label: 'Studio' },
                    { value: 'Unique pieces', label: 'Every creation' },
                    { value: 'Made to order', label: 'Direct contact' }
                ]
            },
            heroShots: {
                tufting: 'Tufting',
                floral: 'Floral bed',
                sunMirror: 'Sun mirror',
                totoro: 'Totoro',
                card3d: '3D card',
                relief3d: '3D relief'
            },
            heroCaption: {
                chip: 'Quick look',
                title: 'Reliefs & volume',
                description: 'A mix of tufting and 3D for original pieces.',
                link: 'Contact the studio'
            },
            highlights: [
                {
                    title: 'Custom tufting',
                    description:
                        'Floor rugs and wall pieces adapted to your colors, sizes and mood.',
                    cta: 'See the process'
                },
                {
                    title: '3D Pokemon cards',
                    description:
                        'Layered cuts for a deep 3D effect.',
                    cta: 'View the collection'
                },
                {
                    title: 'FAQ',
                    description: 'Sizes, timelines, budget and care.',
                    cta: 'Read the FAQ'
                }
            ],
            studio: {
                eyebrow: 'Studio',
                title: 'Recent pieces',
                note: 'A quick look at my latest creations.',
                types: {
                    tufting: 'Tufting',
                    cards: '3D card'
                }
            },
            twitch: {
                eyebrow: 'Live',
                title: 'Twitch, softly',
                note: 'A few studio or gaming streams, not the focus.',
                cardTitle: 'Follow the studio live',
                cardNote:
                    'I go live when I work on a piece or for a gaming session.'
            },
            reviews: {
                eyebrow: 'Reviews',
                title: 'Customer reviews',
                average: 'Average from {count} reviews',
                empty: 'No reviews yet.'
            }
        },
        tufting: {
            hero: {
                eyebrow: 'Tufting',
                title: 'Textile relief pieces, 100% handmade.',
                lead:
                    'Wall rugs, custom formats or decorative objects. Each piece is unique, made for your space.',
                note: 'Need details about sizes, timelines or care?',
                noteLink: 'See the FAQ',
                quote: 'Request a quote',
                estimate: 'Estimate a rug'
            },
            collage: {
                medievalAlt: 'Medieval Banner rug',
                lavaAlt: 'Lava lamp rug',
                sunAlt: 'Sun mirror rug',
                floralAlt: 'Floral bed rug'
            },
            process: {
                eyebrow: 'Process',
                title: 'A simple, clear rhythm',
                note:
                    'Each piece is prepared in the studio with visual updates.',
                steps: [
                    {
                        title: 'Quick brief',
                        description:
                            'We define size, colors and motif for your piece.'
                    },
                    {
                        title: 'Tufting',
                        description:
                            'Yarn application, relief and volume for the right finish.'
                    },
                    {
                        title: 'Finishing',
                        description: 'Glue, trimming and detail cuts.'
                    }
                ]
            },
            library: {
                eyebrow: 'Collection',
                title: 'Selection of tufted pieces',
                note:
                    'Unique pieces. Custom orders on request by email or Instagram DM.'
            },
            filters: {
                all: 'All',
                available: 'Available',
                sold: 'Sold'
            },
            status: {
                available: 'Available',
                sold: 'Sold'
            },
            thumbnails: {
                view: 'View {title} {index}'
            },
            dimensionsFallback: 'Size to confirm',
            quote: 'On request',
            buy: 'Buy',
            cta: {
                eyebrow: 'Custom',
                title: 'Want a unique piece?',
                note:
                    'Send a message with your ideas, sizes and colors to start your project.',
                button: 'Contact the studio'
            }
        },
        cards: {
            hero: {
                eyebrow: '3D Pokemon Cards',
                title: 'Relief cards for collectors.',
                lead:
                    'Pokemon cards cut and layered for a striking 3D effect.',
                contact: 'Contact me'
            },
            signature: {
                eyebrow: 'Signature',
                title: 'Why 3D changes everything',
                note: 'A handcrafted approach that turns a card into art.'
            },
            features: [
                {
                    title: 'Multi-layer relief',
                    description:
                        'Each card is cut and stacked to create real depth.'
                },
                {
                    title: 'Light and depth',
                    description:
                        'Shadows and contrast bring out the details.'
                },
                {
                    title: 'Collector format',
                    description:
                        'Limited edition, each card is chosen together based on feasibility.'
                }
            ],
            collection: {
                eyebrow: 'Collection',
                title: '3D card collection',
                note: 'Classic formats, deep reliefs and custom finishes.'
            },
            filters: {
                all: 'All',
                available: 'Available',
                sold: 'Sold'
            },
            status: {
                available: 'Available',
                sold: 'Sold'
            },
            optionLabels: {
                wallMount: 'Wall mount',
                magnet: 'Magnetic',
                easel: 'Small easel'
            },
            media: {
                imageLabel: '{title} {index}',
                videoLabel: '{title} video {index}',
                viewLabel: 'View {label}'
            },
            buy: 'Buy',
            quote: 'On request',
            request: {
                eyebrow: 'Project request',
                title: 'Build your custom 3D card idea',
                lead:
                    'Search the Pokémon that excites you and let’s shape your project together.',
                openButton: 'Request 3D cards',
                searchLabel: 'Search Pokémon',
                searchPlaceholder: 'Pikachu, Charizard...',
                searchButton: 'Search cards',
                searchError: 'Could not reach tcgdex.dev. {message}',
                searching: 'Searching…',
                searchEmpty: 'Start typing a Pokémon name.',
                noResults: 'No cards found for “{query}”.',
                selectionInstruction:
                    'You can select multiple cards, even from different Pokémon.',
                selectButton: 'Add',
                selectedButton: 'Added',
                selectedCards: 'Selected cards',
                selectionHint: 'They will be listed in the email.',
                selectionEmpty: 'No cards selected yet.',
                removeCard: 'Remove {name}',
                loadMore: 'Load more cards',
                form: {
                    eyebrow: 'Direct contact',
                    emailLabel: 'Your email',
                    messageLabel: 'What you want for your 3D cards',
                    submit: 'Send request',
                    subject: '3D cards request',
                    emptySelection:
                        'Please select at least one card before sending.',
                    submitError: 'Failed to send the request. {message}',
                    botFieldLabel: 'Do not fill out this field',
                    emailRequired: 'Add your email to continue.'
                },
                warning:
                    `Not every card is realizable.
                    The project price depends on the card’s market value.`
                ,
                toastSuccess: 'Request sent! I’ll reply shortly.'
                ,
                legend: 'Badge indicates the card is already marked as realizable.'
                ,
                realisableLegend:
                    'Badge indicates the card is already marked as realizable.'
            },
            process: {
                eyebrow: 'Craft',
                title: 'A clear, precise process',
                optionsTitle: 'Display options',
                options: 'Wall mount €2, small easel €5, magnet €3.',
                steps: [
                    {
                        title: 'Selection',
                        description:
                            'Choice of card, layers and final finish.'
                    },
                    {
                        title: 'Fine cutting',
                        description:
                            'Precision and cleanup for clean edges.'
                    },
                    {
                        title: 'Assembly',
                        description: 'Hand stacking for uniform relief.'
                    }
                ]
            },
            cta: {
                eyebrow: 'Limited edition',
                title: "Let's talk about the Pokemon that inspires you.",
                note:
                    'Not every card is possible. We discuss a Pokemon, then choose a card together before making it in 3D.',
                contact: 'Contact me'
            }
        },
        faq: {
            hero: {
                eyebrow: 'FAQ',
                title: 'Frequently asked questions about tufting and 3D cards.',
                lead:
                    'Sizes, timelines, options and care to prepare your order.'
            },
            actions: {
                viewPieces: 'See the pieces',
                contact: 'Contact the studio'
            },
            heroCard: {
                chip: 'Practical info',
                title: 'Everything is detailed here',
                note:
                    'If something is missing, write to me and I will reply quickly.',
                link: 'Ask a question'
            },
            list: {
                eyebrow: 'Info',
                title: 'Answers to common questions',
                note:
                    'Sizes, prices, timelines and options: the essentials for ordering calmly.'
            },
            groups: {
                tufting: 'Tufting',
                cards: '3D cards'
            },
            tuftingItems: [
                {
                    question: 'What sizes do you offer?',
                    answer:
                        'Up to 75 x 75 cm, from small to large. Wall mounting possible as a free option.'
                },
                {
                    question: 'How does a custom order work?',
                    answer:
                        'We discuss the visual, colors, size and vibe, then I start. 30% deposit before starting.'
                },
                {
                    question: 'What are the production times?',
                    answer: 'On average 1 to 3 weeks depending on my schedule.'
                },
                {
                    question: 'What budget should I plan for?',
                    answer:
                        'Price depends on size, details and time. Free quote on request. Around 40 € for small and up to 200 € for very large.'
                },
                {
                    question: 'Can I choose colors and patterns?',
                    answer:
                        'Yes, everything is customizable: palette, style and final look. The more complex the motif, the more time (and price) increases.'
                },
                {
                    question: 'How to hang a wall piece?',
                    answer:
                        'I attach hooks to hang on the wall with a screw or nail, with several points depending on the rug weight.'
                },
                {
                    question: 'How to care for a rug?',
                    answer:
                        'Gentle vacuum. Do not pull loose strands: trim them. Spot clean with water, do not scrub hard. In the first days, some fibers may come out; trim carefully to the right height.'
                },
                {
                    question: 'Do you ship everywhere?',
                    answer:
                        'Shipping via Vinted or Leboncoin to simplify and reduce cost. Personal shipping is possible with extra fees depending on the carrier.'
                },
                {
                    question: 'Do you accept returns?',
                    answer:
                        'Custom pieces are not returnable, except for a manufacturing issue.'
                }
            ],
            cardsItems: [
                {
                    question:
                        'What display options do you offer (wall mount, stand)?',
                    answer:
                        'Two options are available: a wall mount (2 €) or a small easel stand (5 €), depending on the look you want.'
                },
                {
                    question: 'How do I hang a 3D card on the wall?',
                    answer:
                        'A nail or a screw is enough. With the wall mount, it is easy to install.'
                },
                {
                    question: 'What formats are available for 3D cards?',
                    answer:
                        'For now, Pokemon only. More licenses are coming soon.'
                },
                {
                    question: 'What is the lead time for a custom 3D card?',
                    answer:
                        'About one week, depending on the current schedule.'
                },
                {
                    question: 'Are 3D cards returnable?',
                    answer:
                        'No returns for custom pieces, except for a production issue.'
                }
            ],
            cta: {
                eyebrow: 'Contact',
                title: 'Another question?',
                note:
                    'Tell me your idea and vibe, I will reply quickly.',
                contact: 'Contact the studio'
            }
        },
        modal: {
            eyebrow: 'Estimate',
            title: 'Estimate a tufted rug',
            lead:
                'Adjust the size for a quick estimate. Max {max} x {max} cm.',
            formSubject: 'Rug estimate - {email}',
            formSubjectFallback: 'Rug estimate - missing email',
            close: 'Close window',
            dimensions: {
                chip: 'Dimensions',
                note: 'Custom',
                width: 'Width',
                height: 'Height'
            },
            options: {
                chip: 'Options',
                note: 'Add-ons',
                wallMount: {
                    label: 'Wall mount (0€)',
                    short: 'Wall mount'
                },
                mirror: {
                    label: 'Mirror (15€)',
                    short: 'Mirror'
                },
                shipping: {
                    label: 'Shipping (15€)',
                    short: 'Shipping'
                },
                reference: {
                    label: 'Reference image (optional)',
                    placeholder: 'Add an image',
                    note:
                        'Attach an image (max 8 MB). It will be sent with the request.'
                },
                preview: {
                    button: 'See potential preview',
                    processing: 'Rendering...',
                    success:
                        'Preview generated ({count} colors + black and white).',
                    tooMany:
                        'Image too complex ({count} dominant colors).',
                    error: 'Unable to generate preview.',
                    note:
                        "Colors are indicative: the algorithm can be off, we'll confirm together.",
                    colorsLabel: 'Color count',
                    palette: 'Extracted palette',
                    paletteAvailable: 'Available colors',
                    original: 'Uploaded photo',
                    rendered: 'Simplified preview'
                }
            },
            breakdown: {
                chip: 'Breakdown',
                note: 'Materials + time',
                total: 'Estimated total',
                footnote: 'Indicative price. Final amount may vary.'
            },
            cta: {
                title: 'Ready to start your project?',
                note:
                    'Leave your email so I can get back to you about the project.',
                primary: 'Order',
                submit: 'Send request',
                emailLabel: 'Your email',
                emailPlaceholder: 'you@email.com',
                commentShow: 'Add a comment',
                commentHide: 'Hide comment',
                commentLabel: 'Comment (optional)',
                commentPlaceholder: 'Your message...',
                sending: 'Sending...',
                success: 'Request sent.',
                error: 'Sending failed, please try again.'
            },
            priceLabels: {
                Yarns: 'Yarn',
                Cloth: 'Cloth',
                'Rug Glue': 'Rug glue',
                'Anti-Slip Fabric': 'Anti-slip fabric',
                'Spray Glue': 'Spray glue',
                'Glue Gun': 'Glue gun',
                'Tufting Gun Costs': 'Tufting gun cost',
                'Mower Costs': 'Mower cost',
                'Working Hours': 'Working hours',
                'Edge Cover Strip': 'Edge cover strip'
            },
            email: {
                subject: 'Tufting rug project',
                greeting: 'Hello,',
                intro: 'I am interested in a custom tufted rug.',
                width: 'Width: {value} cm',
                height: 'Height: {value} cm',
                referenceName: 'Reference image: {value}',
                referenceLink: 'Image link: {value}',
                referenceNote:
                    'Link not generated. I will attach the image manually.',
                wallMount: 'Wall mount: 0€',
                mirror: 'Mirror: 15€',
                shipping: 'Shipping: 15€',
                total: 'Estimated total: {value}€',
                thanks: 'Thank you!'
            }
        }
    }
};

export default translations;
